import apiClient from "./api";

export interface Supplier {
  id?: number;
  code: string;
  name: string;
  image?: string;
  email?: string;
  phone?: string;
  address?: string;
  country?: string;
  com_name?: string;
  status?: number;
  created_by?: number;
  updated_by?: number;
  created_at?: string;
  updated_at?: string;
}

export interface PaginatedResponse<T> {
  current_page: number;
  data: T[];
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  links: any[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number;
  total: number;
}

const supplierService = {
  async getSuppliers(params?: any): Promise<PaginatedResponse<Supplier>> {
    const response = await apiClient.get("/suppliers", { params });
    return response.data;
  },

  async getSupplier(id: number): Promise<Supplier> {
    const response = await apiClient.get(`/suppliers/${id}`);
    return response.data.data ?? response.data;
  },

  async createSupplier(input: Supplier): Promise<Supplier> {
    const response = await apiClient.post("/suppliers", input);
    return response.data.data ?? response.data;
  },

  async updateSupplier(id: number, input: Partial<Supplier>): Promise<Supplier> {
    const response = await apiClient.put(`/suppliers/${id}`, input);
    return response.data.data ?? response.data;
  },

  async deleteSupplier(id: number): Promise<void> {
    await apiClient.delete(`/suppliers/${id}`);
  },
};

export default supplierService;
